import {BasicsClass} from "@/common/BasicsClass";
import {Util} from "@/common/util";

export default class PoolTableListAPIClass extends BasicsClass {
    public apiUrls: any = new Map([
        ['list', {
            url: '/poolTable/lists',
            name: 'list',
            label: '球桌列表'
        }],
        ['info', {
            url: '/poolTable/info',
            name: 'info',
            label: '球桌详情'
        }],
        ['save', {
            url: '/poolTable/save',
            name: 'save',
            label: '修改球桌'
        }],
        ['category', {
            url: '/poolTable/category',
            name: 'category',
            label: '球桌分类'
        }],

    ])

    public getList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls
        const url = apiUrls.get('list').url
        this.BasicPost(
            url,
            {
                ...params,
            },
            false,
            false,
            false,
            successCb,
            failCb,
            showLoading
        );
    }
    public info(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls
        const url = apiUrls.get('info').url
        this.BasicPost(
            url,
            {
                ...params,
            },
            false,
            false,
            false,
            successCb,
            failCb,
            showLoading
        );
    }
    public save(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls
        const url = apiUrls.get('save').url
        this.BasicPost(
            url,
            {
                ...params,
            },
            false,
            false,
            false,
            successCb,
            failCb,
            showLoading
        );
    }
    public getCategory(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls
        const url = apiUrls.get('category').url
        this.BasicPost(
            url,
            {
                ...params,
            },
            false,
            false,
            false,
            successCb,
            failCb,
            showLoading
        );
    }


}
